import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { defer, forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordDiscipline } from './models/employment-record-discipline.model';
import { EmploymentRecordDisciplineService } from './services/employment-record-discipline.service';
import { EmploymentRecordDisciplineDialogComponent } from './components/employment-record-discipline-dialog/employment-record-discipline-dialog.component';

@Component({
  selector: 'app-employment-record-discipline',
  templateUrl: './employment-record-discipline.component.html',
  styleUrls: ['./employment-record-discipline.component.scss']
})
export class EmploymentRecordDisciplineComponent implements OnInit {
  @Input() employeeId: string;
  @Input() employmentRecordId: string;
  public columns: any[] = [
    { field: "action", subField: "text", title: "Action", type: "navigation" },
    { field: "reason", subField: "text", title: "Reason" },
    { field: "date", title: "Date", type: "date" },
    { field: "conductedBy", title: "Conducted By" },
    { field: "comments", title: "Comments" },
  ];
  public bindingType: String = "array";
  public view: Observable<GridDataResult>;
  public gridData: any;
  public gridDataResult: GridDataResult;
  isLoading: boolean;
  pageSize: number = 5;
  skip: number = 0;

  constructor(
    private dialog: MatDialog,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private employmentRecordDisciplineService: EmploymentRecordDisciplineService
  ) {}

  ngOnInit(): void {
    this.view = this.employmentRecordDisciplineService.getDisciplines(this.employeeId, this.employmentRecordId);
    this.getDisciplines();
  }

  getDisciplines(): void {
    this.isLoading = true;

    this.employmentRecordDisciplineService.getDisciplines(this.employeeId, this.employmentRecordId, this.pageSize, this.skip)
    .pipe(
        finalize(()=>{ this.isLoading = false; })
    )
    .subscribe(
      res => {
        this.gridDataResult = {
          data: res.disciplines,
          total: res.pagination.TotalCount,
        }
        this.gridData = res.employmentRecords;
      }
    )
  }

  openEmploymentRecordDisciplineDialog(employmentRecordDiscipline?: EmploymentRecordDiscipline) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      employmentRecordId: this.employmentRecordId,
      employeeId: this.employeeId,
      DisciplineId: employmentRecordDiscipline ? employmentRecordDiscipline.id : null
    };

    const dialogRef = this.dialog.open(EmploymentRecordDisciplineDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data === true) {
          this.getDisciplines();
        }
      }
    );
  }

  deleteEmploymentRecordBenefit(employmentRecordDisciplineIds: string[]) {
    const observables = employmentRecordDisciplineIds.map(selectedItem => defer(() => this.employmentRecordDisciplineService.deleteDiscipline(this.employeeId, this.employmentRecordId, selectedItem)));

    this.overlayService.show();

    forkJoin(observables)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.getDisciplines();
        this.snackbarService.openSnackBar('Deleted successfully', 'clear', 'success');
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take
    this.getDisciplines();
  }

}
